import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useTextInput, { TextInput } from "@/components/form/text-input";
import useSelectInput, { SelectInput } from "@/components/form/select-input";

const S03 = (props) => {
    const sale = useRadioInput({
        name: "sale[sold][detail]", label: "Hvordan ble salget gjennomført?",
        options: {
            data: [
                { label: "Salget ble gjennomført som privatperson", value: "PRIVATEPERSON" },
                { label: "Salget ble gjennomført i næringsvirksomhet", value: "COMPANY" },
                { label: "Salget ble gjennomført gjennom et mellomledd (formidlingssalg)", value: "INTERMEDIARY" },
                { label: "Salget ble aldri gjennomført", value: "WAS_NOT_SOLD" },
            ],
        },
        ...props,
    })

    const bindingContract = useRadioInput({
        name: "sale[is_binding]", label: "Gjelder saken om det er inngått en bindende avtale om kjøp eller ikke?",
        className: "mt-7",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei", value: "FALSE" },
            ],
        },
        ...props,
    })

    const otherIssue = useTextInput({
        name: "sale[description]",
        className: "mt-7",
        label: "Kan du forklare nærmere hva du mener saken omhandler?",
        placeholder: "Utdyp her...",
        ...props,
    })

    const counterpart = useRadioInput({
        name: "counterpart[type]", label: "Hvem er kjøper?",
        className: "mt-7",
        options: {
            data: [
                { label: "Kjøper er privatperson", value: "PRIVATEPERSON" },
                { label: "Kjøper har kjøpt som næringsdrivende/firma", value: "COMPANY" },
            ],
        },
        ...props,
    })

    const insuranceCompany = useSelectInput({
        name: "sale[car][insurance][company]",
        className: "mt-7",
        label: "I hvilket selskap var bilen forsikret?",
        options: {
            includeBlank: "Velg et selskap",
            data: [
                { label: "Bilen var ikke forsikret", value: "NOT_INSURED" },
                { label: "If", value: "IF" },
                { label: "Help Forsikring", value: "HELP" },
                { label: "Gjensidige", value: "GJENSIDIGE" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om salget">
            <RadioInput {...sale.props}/>

            { sale.is("WAS_NOT_SOLD") &&
                <>
                    <RadioInput {...bindingContract.props}/>
                    { bindingContract.is("FALSE") && <TextInput {...otherIssue.props} className="mt-4"/> }
                </>
            }

            { sale.isNot("WAS_NOT_SOLD") &&
                <>
                    <RadioInput {...counterpart.props}/>
                    {/*<SelectInput {...insuranceCompany.props}/>*/}
                </>
            }
        </Wrapper>
    );
};

export default S03;
